export default __webpack_public_path__ + "static/media/WF.e8d7ca11.svg";